import {
  Box,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

const SubscriptionCommisionsTable = ({ refresh, onEdit }) => {
  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchCommissions = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `/subscription/subscription-commisions/`
        );
        setCommissions(response?.data);
      } catch (error) {
        console.log("Error Fetching Commissions", error);
        toast.error("Error fetching Commissions");
      } finally {
        setLoading(false);
      }
    };
    fetchCommissions();
  }, [refresh]);

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        All Subscription Commissions
      </Typography>
      {loading ? (
        <Box display="flex" mt={3}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Subscription Plan ID</TableCell>
                  <TableCell>Commission Amount</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {commissions.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No commissions found.
                    </TableCell>
                  </TableRow>
                ) : (
                  commissions.map((item, index) => (
                    <TableRow key={item.id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.subscriptionplan_name}</TableCell>
                      <TableCell>₹{item.commision_amount}</TableCell>
                      <TableCell>{item.status}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => onEdit(item)}>
                          <EditIcon color="primary" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  );
};

export default SubscriptionCommisionsTable;
